import type { FunctionComponent, SVGProps } from "react";

/** SVG from `import { ReactComponent as X } from '*.svg'` (CRA / SVGR). */
export type SvgIcon = FunctionComponent<
  SVGProps<SVGSVGElement> & { title?: string }
>;

export enum EntityType {
  Individual = "individual",
  Entity = "entity",
}

export enum DocumentType {
  Passport = "passport",
  IdCard = "idCard",
  IdCardBack = "idCardBack",
  Selfie = "selfie",
  ProofAddress = "proofOfAddress",
  UtilityBill = "utilityBill",
  Avatar = "avatar",
}

export enum AssetType {
  Stock = 1, // Акция
  PreferredShare = 2, // Привилегерованная Акция
  Bond = 3,
  ADR_GDR = 4, // АДР ГДР
  Currency = 5, // Валюта
  EuroBond = 6, // Еврооблигация
  Fond = 7, // Фонд
  ETF = 8,
  StructuredProduct = 9, // Структурированный Продукт
  Option = 10, // Опцион
  Future = 11, // Фьючерс
  // Favorites = 20
  Crypto = 30, // Криптовалюта
}

export const AssetTypes: Record<number, string> = {
  [AssetType.Stock]: "Stocks",
  [AssetType.PreferredShare]: "",
  [AssetType.Bond]: "Bonds",
  [AssetType.ADR_GDR]: "",
  [AssetType.Currency]: "Currencies",
  [AssetType.EuroBond]: "Eurobonds",
  [AssetType.Fond]: "Fonds",
  [AssetType.ETF]: "ETF",
  [AssetType.StructuredProduct]: "Strategies",
  [AssetType.Option]: "Options",
  [AssetType.Future]: "Futures",
  [AssetType.Crypto]: "Cryptos",
};

export enum OrderType {
  Market = "market",
  Limit = "limit",
}

export enum OrderTifType {
  Day = "day", // На день
  GoodTillCancel = "gtc", // До отмены
  ImmediateOrCancel = "ioc", // Немедленное исполнение или отмена
  FillOrKill = "fok", // Полное исполнение или отмена
  GoodTillDate = "gtd", // До определенной даты
  AtTheOpening = "ato", // На открытие
  AtTheClose = "atc", // По закрытию
  Month = "month", // На месяц
  Session = "session", // На сессию
}

export enum OperationType {
  Buy = "buy",
  Sell = "sell",
}

export enum OperationStatus {
  Actively = 1, // Активно
  Completed = 2, // Исполнено
  Canceled = 3, // Отменено
  CancellationRequest = 4, // Запрос На Отмену
  OnPerformance = 5, // На Исполнении
  Error = 6, // Ошибка
  Refusal = 7, // Отказ
  Expired = 8, // Истек Срок
  PartiallyCompleted = 9, // Частично Исполнено
  NotExecuted = 10, // Не Исполнено
  WithdrawnClients = 11, // Отозвано Клиентов
}

export const IsVelarApp =
  process.env.REACT_APP_IS_VELAR_APP === "true" || false;
